module.exports = {
  API_DOMAIN: 'https://api.fulfillment.qc.viralstyle.com/',
  API_URL: 'https://api.fulfillment.qc.viralstyle.com/v1/',
  CDN: '/',
};
